import { useQuery } from '@tanstack/react-query';
import { describeApiError, getAccessTokenRoles } from './apiClient';

/** App role that authorizes writes (enforced by the API; the UI only mirrors it). */
export const WRITE_ROLE = 'Audit.Admin';

export const WRITE_ROLE_REQUIRED_MESSAGE =
  'Requires the Audit Admin role. Ask an administrator to assign it in Entra ID > ' +
  'Enterprise apps > MPAA-Functions-API > Users and groups.';

/**
 * Whether the signed-in user may perform write actions (Apply, Run Audit Now, alert
 * settings). Read from the `roles` claim of the existing API token.
 * `reason` is the tooltip text when writes are unavailable (null when allowed).
 */
export function useWritePermission() {
  const query = useQuery({
    queryKey: ['auth', 'roles'],
    queryFn: getAccessTokenRoles,
    staleTime: 5 * 60_000,
    retry: false,
  });
  const roles = query.data ?? [];
  const canWrite = roles.includes(WRITE_ROLE);
  const reason = canWrite
    ? null
    : query.isLoading
      ? 'Checking your permissions…'
      : query.error
        ? `Could not read your permissions — ${describeApiError(query.error)}`
        : WRITE_ROLE_REQUIRED_MESSAGE;
  return { canWrite, reason, roles, isLoading: query.isLoading };
}
